
export function TRY<T>(fn: () => T): [null | Error, null | T] {
  try {
    return [null, fn()];
  } catch (error) {
    return [error as Error, null];
  }
}
